import { useState } from 'react';
import { ButtonMain } from '@quero-delivery/quero-components-web';
import { AccessPermission } from '@/_components/access-permission';

import PurpleButton from '@/Components/shared/purple-button/PurpleButton';
import styles from './launch-bank.module.scss';
import { ModalLaunch } from '../modal-launch';
import { ENUM_LAUNCH, type Launch, type LaunchBankProps } from './types';

// TODO Impelementar testes e refatorar requests
function LaunchBank({ userType }: LaunchBankProps) {
  const [launchType, setLaunchType] = useState<Launch | null>();

  const [openModalLaunch, setOpenModalLaunch] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.buttonsContainer}>
        <AccessPermission permissionKey="place.credit">
          <PurpleButton
            textEnd="Lançar crédito"
            secondary
            width="100%"
            onClick={() => {
              setLaunchType(ENUM_LAUNCH.CREDITO);
              setOpenModalLaunch(true);
            }}
          />
        </AccessPermission>
        <AccessPermission permissionKey="place.debit">
          <ButtonMain
            textEnd="Lançar débito"
            className={styles.buttonDebit}
            width="100%"
            secondary
            onClick={() => {
              setLaunchType(ENUM_LAUNCH.DEBITO);
              setOpenModalLaunch(true);
            }}
          />
        </AccessPermission>
      </div>

      <ModalLaunch
        open={openModalLaunch && !!launchType}
        onClose={() => setOpenModalLaunch(false)}
        launchType={launchType || ENUM_LAUNCH.CREDITO}
        userType={userType}
      />
    </div>
  );
}

export { LaunchBank };
